<template>
  <b-container class="p-0">
    <b-row class="my-2 mx-0">
      <b-col>
        <h5 class="font-weight-bold">{{ isUpdate ? 'Update' : 'Create' }} Divalto Code</h5>
        <hr />
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <b-form-group label="Element Type" label-for="elementType">
          <b-form-input
            id="elementType"
            v-model="element_type"
            placeholder="Enter element type"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <b-form-group label="Code" label-for="elementCode">
          <b-form-input
            id="elementCode"
            v-model="element_code"
            placeholder="Enter code"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <b-form-group label="Description" label-for="shortDescription">
          <b-form-textarea
            id="shortDescription"
            v-model="short_description"
            placeholder="Enter description"
            rows="3"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <b-form-group label="Unit" label-for="unit">
          <b-form-select
            id="unit"
            v-model="cunit"
            placeholder="Select unit"
            :options="unitOptions"
          >
        </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <b-form-group label="Agency" label-for="agency_code">
          <b-form-select
            id="agency_code"
            v-model="company_code"
            placeholder="Select Agency"
            :options="companyCodeOptions"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="my-2">
      <b-col>
        <b-form-group label="Company Code" label-for="divaltoCompanyCode">
          <b-form-input
            id="divaltoCompanyCode"
            v-model="divalto_company_code"
            placeholder="Enter company code"
          />
        </b-form-group>
      </b-col>
    </b-row>


    <b-row class="justify-content-end">
      <b-col cols="auto">
        <b-button variant="secondary" @click="handleClose">Close</b-button>
      </b-col>
      <b-col cols="auto">
        <b-button variant="primary" @click="handleSave">{{ isUpdate ? 'Update' : 'Save' }}</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "DivaltoCodesForm",
  props: {
    componentData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      element_type: this.componentData.item?.element_type || '',
      element_code: this.componentData.item?.element_code || '',
      short_description: this.componentData.item?.short_description || '',
      cunit: this.componentData.item?.cunit || '',
      company_code: this.componentData.item?.company_code || '',
      divalto_company_code: this.componentData.item?.divalto_company_code || '',
      companyCodeOptions: [],
      unitOptions: ['U', 'ML', 'M2', 'ENS', 'F', 'J', 'M', 'T']
    };
  },
  computed: {
    isUpdate() {
      return !!this.componentData.id;
    }
  },
  created(){
    this.fetchCompanies()
  },
  methods: {
    async handleSave() {
      if (!this.element_type || !this.element_code || !this.company_code || !this.cunit) {
        this.$emit('toast-message', {
          message: 'Please fill out required fields',
          variant: 'danger',
        });
        return;
      }
      try {
        await this.$store.dispatch('session/refresh');
        if (this.isUpdate) {
          await this.$store.dispatch('divaltoCodes/updateCode', {
            id: this.componentData.id,
            element_type: this.element_type,
            element_code: this.element_code,
            short_description: this.short_description,
            cunit: this.cunit,
            company_code: this.company_code,
            divalto_company_code: this.divalto_company_code
          });
          alert('Divalto Code updated successfully');
          this.$emit('toast-message', {
            message: 'Divalto Code updated successfully',
            variant: 'success',
          });
        } else {
          await this.$store.dispatch('divaltoCodes/createCode', {
            element_type: this.element_type,
            element_code: this.element_code,
            short_description: this.short_description,
            cunit: this.cunit,
            company_code: this.company_code,
            divalto_company_code: this.divalto_company_code
          });
          alert('Divalto Code created successfully');
          this.$emit('toast-message', {
            message: 'Divalto Code created successfully',
            variant: 'success',
          });
        }

        this.$emit("save-code", {
          element_type: this.element_type,
          element_code: this.element_code,
          short_description: this.short_description,
          cunit: this.cunit,
          company_code: this.company_code,
          divalto_company_code: this.divalto_company_code
        });

        this.handleClose();
      } catch (error) {
        console.error('Error saving code:', error);
        alert('Failed to save the item');
        this.$emit('toast-message', {
          message: 'Failed to save the item: ' + error.message,
          variant: 'danger',
        });
      }
    },

    handleClose() {
      this.$store.dispatch('ui/modal.close');
    },

    async fetchCompanies() {
      try {
        const agencies = await this.$store.dispatch('divaltoAgencies/all', { config: {} });
        this.companyCodeOptions = agencies.data?.map(agency => ({
          text: agency?.name,
          value: agency?.code
        }));
      } catch (error) {
        console.error('Error fetching company codes:', error);
        this.companyCodeOptions = [];
      }
    }
  }

};
</script>

<style scoped>
.input-full-width {
  flex-grow: 1;
}
</style>
